import type { HtmlAttributes } from '@studio/design-system/props';
import { toUri } from '@studio/models/control';
import type { PTZ } from '@studio/models/ptz';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { shallow } from 'zustand/shallow';
import { useStore } from '../store/hooks.js';
import { Navipad } from '#~/control/components/editor/index.js';
import { move } from '#~/control/movement/commands/index.js';

/** `<Controller>` component. */
export const Controller = (props: HtmlAttributes): ReactElement => {
  const store = useStore(({ candidate }) => {
    const { control, id, modelId } = candidate;
    const disabled = !control || !toUri(control, { modelId });

    return {
      disabled,
      id
    };
  }, shallow);

  const handleMove = useLatestFn((intent: PTZ) => {
    const { disabled, id } = store;

    if (!disabled) {
      move(id, intent);
    }
  });

  return <Navipad {...props} deviceId={store.id} disabled={store.disabled} onMove={handleMove} />;
};
